const roles = [
  {
    value: 'TRANSPORTER_SUPER_ADMIN',
    label: 'Transporter Super Admin'
  },
  {
    value: 'TRANSPORTER_ADMIN',
    label: 'Transporter Admin'
  },
  {
    value: 'TRANSPORTER_MONITORING',
    label: 'Transporter Monitoring'
  },
  {
    value: 'TRANSPORTER_ADMIN_FAA',
    label: 'Transporter Admin FAA'
  },
]

const getRoleText = function (value) {
  console.log('TCL: getRoleText -> value', value)
  const role = roles.find(i => i.value === value)
  return (role && role.label) || ''
}

export default {
  userAdminDatabase: 'Database User Admin',
  edit: 'Ubah User Admin',
  create: 'Buat User Admin Baru',
  searchText: 'Cari Nama Admin',
  name: 'Nama',
  phone: 'No telepon',
  email: 'Email',
  role: 'Role',
  userAdminDeleteConfirmMsg: 'Apakah Anda yakin ingin menghapus akun ini?',
  userAdminDeleteSuccessMsg: 'Berhasil menghapus akun',
  resetPasswordButtonLabel: 'Reset Password',
  resetPasswordConfirmMsg: 'Apakah Anda yakin ingin me-reset password akun ini?',
  resetPasswordSuccessMsg: 'Berhasil me-reset password akun',
  roles,
  getRoleText,
}
